module.exports = __webpack_public_path__ + "static/media/icon-expand.d0b3fa8b.svg";


//////////////////
// WEBPACK FOOTER
// ./src/common/compare-section/img/icon-expand.svg
// module id = 960
// module chunks = 1